export * from './servicePlan.service';
import { ServicePlanService } from './servicePlan.service';
export const APIS = [ServicePlanService];
